export default {
  signUpSuccess: 'Successfully registered! You\'ve been signed in as well.',
  signUpFailure: 'Registration failed. Email may be taked, or passwords don\'t'
                  + ' match.',
  signInSuccess: 'Welcome!',
  signInFailure: 'Failed to sign in. Your email or password may be incorrect,' +
                  ' or you may have tried to sign in to an account type you' +
                  ' don\'t have.',
  signOutSuccess: 'Come back soon!',
  changePasswordSuccess: 'Password changed successfully!',
  changePasswordFailure: 'Failed to change passwords. Check your old password' +
                         ' and try again.',
  editProfileSuccess: 'Succesfully updated profile!',
  editProfileFailure: 'Update failed. Data may be invalid.',
  mismatchingPasswords: 'Error. Passwords do not match.',
  badZipCode: 'Invalid zip code. Zip code must be a five digit number and' +
              ' correspond to a valid US postal code.',
  cannotReachServer: 'Error. Cannot reach server.'
}



// WEBPACK FOOTER //
// ./src/auth/messages.js